// HOOKS
import { useState } from "react";
// COMPONENTS
import { ReactComponent as HelpIcon } from "../../assets/icons/help.icon.svg";
import Popover from "./popover.component";

const DEFAULT_CLASSNAMES = {
  helpIcon: "fill-secondary h-6 w-6",
  popover: {
    container:
      "font-ubuntuRegular backdrop-blur-sm z-40 right-full top-0 absolute flex flex-col justify-center bg-greenGlass rounded-lg p-2",
  },
};

const HelpPopover = ({ classNames = DEFAULT_CLASSNAMES, children }) => {
  const [showPopover, setShowPopover] = useState(false);
  return (
    <div className="relative">
      <HelpIcon
        onMouseEnter={() => setShowPopover(true)}
        onMouseLeave={() => setShowPopover(false)}
        className={classNames?.helpIcon || DEFAULT_CLASSNAMES.helpIcon}
      />
      {/* popover */}
      {showPopover && (
        <Popover classNames={classNames?.popover || DEFAULT_CLASSNAMES.popover}>
          {children}
        </Popover>
      )}
    </div>
  );
};

export default HelpPopover;
